import React, { useEffect, useState, useRef } from "react";
// @material-ui/core components
// core components
import DataTable from "react-data-table-component";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../../components/DialogTitle/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { API_POST } from "../../services/api.service";
import Chip from "@material-ui/core/Chip";
import CommonMapping from "./../CommonMapping/CommonMapping";
import {  Typography } from "@material-ui/core";
import PluginZip from "../../assets/betyphon-integration-with-wordpress.zip"; 
function WOrdpressPluginDownload(props) {
  const { classes, user, open, defaultData, IsEdit } = props;
  const [hookData, sethookData] = useState([]);
  const [Campaigns, setCampaigns] = useState([]);
  const [idInput, setIdInput] = useState("");
  const [api, setApi] = useState(
    "https://www.commonfloor.com/agent/pull-leads/v1?id=${id}&key=${key}&start=${startdate}&end=${enddate}"
  );
  
  const [apiVersion,setApiVersion]= useState(1);
  const [InputType, setInputType] = useState("");
  const [keyInput, setKeyInput] = useState([]);
  const [MappingVal, setMappingVal] = useState([]);
  const [MappingWithMulObject, setMappingWithMulObject] = useState([]);

  const [PreviewData, setPreviewData] = useState([]);
  const [IsShowFieldMapping, setIsShowFieldMapping] = useState(false);
  const [IsShowTestBtn, setIsShowTestBtn] = useState(false);
  const [IsPreviewData, setIsPreviewData] = useState(false);

  const [columns, setcolumns] = useState([]);
  const [mapping, setMapping] = useState([]);
  const [chkResult, setChkResult] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [IsTestBtnClicked, setIsTestBtnClicked] = useState(false);
  const [IsSaved, setIsSaved] = useState(false);

  const childRef = useRef();

  const handleClose = () => {
    props.handleClose();
  };

  const [notify, setNotify] = useState({
    open: false,
    message: null,
    color: "success",
  });

  useEffect(() => {
    if (props.user) {
      loadCampaign();
    }
  }, [props.user]);

  useEffect(() => {

    if (open && defaultData && defaultData.hasOwnProperty("cid")) {
      console.log(defaultData);

      //setApi(defaultData.api);
      setInputType({ id: defaultData.cid, name: defaultData.campaign });
      setMappingWithMulObject(defaultData.Mapping);

      let obj = defaultData.Mapping.reduce(function (result, current) {
        return Object.assign(result, current);
      }, {});


      setPreviewData([obj]);
      setMappingVal(obj);
      setIsShowFieldMapping(true);
      setIdInput(defaultData.values[0].id);
      setKeyInput(defaultData.values[1].key);
    }
    else {

      setInputType("");
      setMappingWithMulObject([]);
      setPreviewData([]);
      setMappingVal();
      setIsShowFieldMapping(false);
      setIdInput([]);
      setKeyInput([]);
    }
  }, [defaultData]);

  const loadCampaign = async () => {
    const { user } = props;
    let registerRequest;
    try {
      registerRequest = await API_POST("action/getdata", {
        root: "campaigns",
        con: { admin: user && user.admin, IsActive: true },
      });

      if (registerRequest && registerRequest.status == 200) {
        if (registerRequest.data.length > 0) {
          setCampaigns(registerRequest.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTest = async () => {
    let url = api;
    let startdate = window
      .moment()
      .subtract(1, 'days')
      .format("YYYYMMDD")
      .toUpperCase();
    let enddate = window
      .moment()
      .format("YYYYMMDD")
      .toUpperCase();

    url = url.replace("${startdate}", startdate);
    url = url.replace("${enddate}", enddate);
    url = url.replace("${id}", idInput);
    url = url.replace("${key}", keyInput);



    let data = await API_POST(`register/GetAPIData`, { url });
    
    console.log('XML Data:', data);
    handleXmlData(data.data.apiData);

  };

  //api
  const handleXmlData = (xmlData) => {
        try {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlData, 'application/xml');
      
          const cfLeads = xmlDoc.getElementsByTagName('cf_lead');
          const convertedData = Array.from(cfLeads).map(cfLead => {
            const newObj = {};
            Array.from(cfLead.children).forEach(child => {
              newObj[child.tagName] = child.textContent;
            });
            return newObj;
          });
      
          console.log('Converted Data:', convertedData);
      
          if (convertedData && convertedData[0]) {
            setPreviewData([convertedData[0]]);
            setMappingVal(convertedData[0]);
            setIsTestBtnClicked(true);
            setIsShowFieldMapping(true);
            if (convertedData[0].Error_Message) {
              setNotify({
                open: true,
                message: convertedData[0].Error_Message,
                color: "danger",
              });
            } else {
              // Additional logic if needed
            }
          } else {
            setNotify({
              open: true,
              message: "No Recent Data Found",
              color: "success",
            });
          }
        } catch (error) {
          console.error('Error parsing XML:', error);
        }
  };

  const handleSave = async (e) => {
    childRef.current.handleAdd();
  };

  const handleSaveIntegration = async () => {
    let payload = {
      name: "CommonFloor",
      admin: user && user.admin,
      campaign: InputType.name,
      cid: InputType._id,
      api: api,
      values: [
        {
          id: idInput,
        },
        {
          key: keyInput,
        },
      ],
      Mapping: mapping,
      dateFormat: "YYYYMMDD",
      IsActive: true,
      apiVersion:apiVersion
    };

    let registerRequest;
    try {
      registerRequest = await API_POST("action/upsert", {
        root: "Integrations",
        body: payload,
        querydata: { admin: user.admin, name: "CommonFloor" },
      });

      if (registerRequest && registerRequest.status == 200) {
        setNotify({
          open: true,
          message: "Data Save Successfully",
          color: "success",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (IsSaved) {
      props.CallloadIntegrationList();
      handleSaveIntegration();
      setIsSaved(false);
    }
  }, [IsSaved]);

  const handleBlur = async (e) => {

    if (e.target.name == "Id" || e.target.name == "Key") {
      if (idInput != "" && keyInput != "") { setIsShowTestBtn(true); }
      else setIsShowTestBtn(false);
    }
  };

  let col = [];
  const handlePreview = async () => {
    debugger;
    if (
      PreviewData.length == 0 &&
      !PreviewData[0].hasOwnProperty("Error_Message")
    ) {
      setNotify({
        open: true,
        message: "Please first click on test btn to show mapping.",
        color: "danger",
      });
    } else {
      let obj = {};
      for (var key in PreviewData[0]) {
        if (PreviewData[0].hasOwnProperty(key)) {
          obj = {};
          //obj = { name: key, selector: PreviewData[0][key] };
          obj = { name: key, selector: key };
          col.push(obj);
        }
      }
      debugger;
      setcolumns(col);
      setIsPreviewData(true);
    }
  };

  const bindMapping = (mapping) => {
    setChkResult(true);
    setMapping(mapping);
    setIsSaved(true);
  };

  return (
    <GridContainer>
      <Snackbar
        place="tr"
        color={notify.color}
        message={notify.message}
        open={notify.open}
        closeNotification={() => setNotify({ open: false })}
        close
      />
     <Dialog open={open} fullWidth={false} maxWidth="sm">
  <DialogTitle
    id="customized-dialog-title"
    style={{ textAlign: "center", fontWeight: "bold", fontSize: "22px", letterSpacing: "1px" }}
  >
    STEPS TO INSTALL WORDPRESS PLUGIN of BeTyphon
  </DialogTitle>

  <DialogContent
    style={{
      textAlign: "center",
      padding: "0px 40px",
    }}
  >
    {/* Steps Heading */}
    {/* <Typography
      variant="p"
      gutterBottom
      style={{ fontWeight: "bold", marginBottom: "15px" }}
    >
     Follow the Guide to map Column with Betyphon Campaign - https://betyphon.tawk.help/article/how-to-map-wordpress-website-column-with-betyphon-colum-for-lead-entry
    </Typography> */}

    {/* Steps List */}
    <ol
      style={{
        textAlign: "left",
        display: "inline-block",
        margin: "0 auto",
        paddingLeft: "20px",
        lineHeight: "1.8",
        fontSize: "16px",
        maxWidth: "500px",
      }}
    >
      <li>Download the plugin zip file using the button below.</li>
      <li>Login to your WordPress Admin Dashboard.</li>
      <li>
        Go to <b>Plugins → Add New → Upload Plugin</b>.
      </li>
      <li>
        Choose the downloaded ZIP file and click <b>Install Now</b>.
      </li>
      <li>
        After installation, click <b>Activate Plugin</b>.
      </li>
    </ol>
    <Typography
  variant="body2"
  style={{ fontSize: "13px", wordBreak: "break-word", marginTop: "15px" }}
>
    Follow the Guide to map Column with Betyphon Campaign -<br/>
  <a 
    href="https://betyphon.tawk.help/article/how-to-map-wordpress-website-column-with-betyphon-colum-for-lead-entry"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#1976d2", textDecoration: "none", fontWeight: "500" }}
  >
    https://betyphon.tawk.help/article/how-to-map-wordpress-website-column-with-betyphon-colum-for-lead-entry
  </a>
</Typography>
  </DialogContent>

  <DialogActions
    style={{
      justifyContent: "center",
      paddingBottom: "20px",
    }}
  >
    {/* Download Plugin Button */}
    <Button
      variant="contained"
      color="secondary"
      href={PluginZip}
      download="betyphon-wordpress-integration.zip"

      style={{
        background: "#4CAF50",
        color: "#fff",
        fontWeight: "bold",
        padding: "8px 20px",
        borderRadius: "8px",
        marginRight: "10px",
      }}
    >
      Download Plugin
    </Button>

    <Button
      onClick={handleClose}
      style={{
        background: "#00ACC1",
        color: "#fff",
        fontWeight: "bold",
        padding: "8px 20px",
        borderRadius: "8px",
      }}
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>

    </GridContainer>
  );
}

export default WOrdpressPluginDownload;

